<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"               
                flat
                dark
              >
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="email"
                    label="E-mail"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                    @keyup.enter="login()"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    @keyup.enter="login()"
                  ></v-text-field>

                  <v-text-field
                    v-model="token"
                    label="Token (optional)"
                    name="token"
                    prepend-icon="mdi-check"
                    type="token"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="login()" color="secondary">Login</v-btn>
                <v-btn @click="goToPasswordReset()" color="secondary">Reset password</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { tokenAuthenticator } from '../../tokenAuthenticator'
import { LOGIN_MUTATION } from '../../graphql/authenticationQueries.js';

  export default {
    data () {
      return {
        email: null,
        password: null,
        token: null
      }
    },
    apollo: {
      $client: 'authenticationClient'
    },
    methods: {
      async login(){
        const { email, password, token } = this.$data;
        try {
          const result = await this.$apollo.mutate({
            mutation: LOGIN_MUTATION,
            variables: {
              email: email,
              password: password,
              token: token
            }
          });

          if(result.data.login)
          {
            if (result.data.login.status == "OK")
            {
              const accessToken = result.data.login.accessToken;
              const accessTokenExpirySeconds = result.data.login.accessTokenExpirySeconds;
              
              tokenAuthenticator.storeToken(accessToken, accessTokenExpirySeconds);

              // Emit message to other modules
              this.$bus.$emit('login', '');

              // Goto home (/) page
              this.$router.push({ name: 'Home'}); 
            } 
            else 
            {
              alert(result.data.login.status);
            }
          }
        } catch (error) {
          alert('Something went wrong when trying to login.');
        }
      },

      goToPasswordReset(){
        this.$router.push({ name: 'PasswordReset'}); 
      }
    }
  }
</script>